function initSampleAddToCart() {
  document.querySelectorAll('.sample-add-to-cart[id^="SampleAddToCart-"]').forEach((widget) => {
    if (widget.dataset.initialized === 'true') return;
    widget.dataset.initialized = 'true';

    const button = widget.querySelector('.sample-add-to-cart__button');
    const result = widget.querySelector('.sample-add-to-cart__result');
    if (!button) return;

    const successText = widget.dataset.successText || 'Sample added to your cart!';

    button.addEventListener('click', () => {
      const selected = widget.querySelector('input[type="radio"]:checked');

      if (!selected) {
        if (result) result.textContent = 'Please choose a material first.';
        return;
      }

      if (button.getAttribute('aria-disabled') === 'true') return;

      const variantId = selected.value;
      const originalText = button.textContent;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding...';
      if (result) result.textContent = '';

      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }

      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const message =
              response.description || response.message || 'Could not add that sample to your cart.';
            if (result) result.textContent = message;

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'sample-add-to-cart',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            return;
          }

          if (result) result.textContent = successText;

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sample-add-to-cart',
              productVariantId: variantId,
              cartData: response,
            });
          }

          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            cart.renderContents(response);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => {
          if (result) result.textContent = 'Something went wrong. Please try again.';
        })
        .finally(() => {
          button.removeAttribute('aria-disabled');
          button.textContent = originalText;
        });
    });
  });
}

document.addEventListener('DOMContentLoaded', initSampleAddToCart);
document.addEventListener('shopify:section:load', initSampleAddToCart);
document.addEventListener('shopify:block:select', initSampleAddToCart);
